import React, {Component} from 'react';
import './HomePageHeader.css';
import Navbar from './Navbar/Navbar'
import TabletNavbar from './TabletNavbar/TabletNavbar'

class HomePageHeader extends Component {
  constructor(props) {
    super(props);
    this.isTablet=false;
    this.state = {
      menuIsOpen: false,
    }
    // this.isTablet = window.innerWidth < 1240
}
  onMenuClick=()=>{
    this.setState({
    menuIsOpen:!this.state.menuIsOpen
  })
  }


  render() {
    return (
      <div className="home_header_container" id='home_header' >
        <div className='header'>
            <div className='tabletMenu' onClick={this.onMenuClick}>
              <span className='fas fa-bars'></span>
            </div>
          <div className='header_logo'></div>
          {this.state.menuIsOpen && <TabletNavbar/> }
            <Navbar />
        </div>
      </div>
    )
  }


}
// let isTablet = window.innerWidth < 1240 && true;

export default (HomePageHeader);



// WEBPACK FOOTER //
// ./src/components/Home/HomePageHeader/HomePageHeader.jsx